exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".moveLightNickname{margin:20px 30%}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/admin/Lights/ChangeFieldModal.vue"],"names":[],"mappings":"AACA,mBACE,eAAiB,CAClB","file":"ChangeFieldModal.vue","sourcesContent":["\n.moveLightNickname {\n  margin: 20px 30%;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-703cc5a3","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/Lights/ChangeFieldModal.vue
// module id = 1168
// module chunks = 7